import React from 'react';

import { getLoginLink } from '@confluence/login-if-anonymous/entry-points/getLoginLink';
import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState';
import { useSessionData } from '@confluence/session-data';

import { BaseHeartbeatLoadable } from './HeartBeatLoadable';

export const Heartbeat = () => {
	const { isLoggedIn } = useSessionData();
	const { push } = useRouteActions();

	return isLoggedIn ? (
		<BaseHeartbeatLoadable onAuthenticationFailed={() => push(getLoginLink())} />
	) : null;
};
